import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import { portalConfig } from '../configs/portal';

export const LANGUAGE_KEY = `connectedheart:${portalConfig.id}:language`;
export const languages = [{ value: 'pt', label: 'Português' }, { value: 'en', label: 'English' }];

export const readPreferredLanguage = () => {
    try {
        const stored = localStorage.getItem(LANGUAGE_KEY);
        return languages.some((language) => language.value === stored) ? stored : 'pt';
    } catch { return 'pt'; }
};

const pt = Object.fromEntries(Object.keys(en).map((key) => [key, key]));
i18n.use(initReactI18next);
i18n.init({
    lng: readPreferredLanguage(),
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en'],
    resources: { pt: { translation: pt }, en: { translation: en } },
    keySeparator: false,
    nsSeparator: false,
    initImmediate: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false }
});

// Accept optional helper/error text without translating user-entered data.
export const t = (value) => {
    if (typeof value !== 'string' || !value) return value;
    if (i18n.exists(value)) return i18n.t(value);
    const trimmed = value.trim();
    return value.replace(trimmed, i18n.t(trimmed));
};

const syncDocument = () => {
    if (typeof document === 'undefined') return;
    document.documentElement.lang = i18n.resolvedLanguage === 'en' ? 'en-GB' : 'pt-PT';
    document.title = `ConnectedHeart | ${t(portalConfig.title)}`;
};

i18n.on('languageChanged', (language) => {
    try { localStorage.setItem(LANGUAGE_KEY, language); } catch { /* Keep the session usable when storage is unavailable. */ }
    syncDocument();
});
syncDocument();

export const changeInterfaceLanguage = async (language) => {
    if (!languages.some((option) => option.value === language)) throw new Error('UNSUPPORTED_LANGUAGE');
    await i18n.changeLanguage(language);
};

export default i18n;
